import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(
          _vm._s(
            _vm.mode == "create"
              ? _vm.$t("chatbots.projects.create_project")
              : _vm.mode == "edit"
              ? _vm.$t("chatbots.projects.update_project")
              : _vm.$t("chatbots.projects.view_project")
          )
        ),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, { staticClass: "pa-0" }, [
                _vm._v(_vm._s(_vm.$t("chatbots.projects.project_description"))),
              ]),
            ],
            1
          ),
          _c("template", { slot: "actions" }),
        ],
        2
      ),
      _c(
        VForm,
        { ref: "form_project", attrs: { id: "form_project" } },
        [
          _c(
            VStepper,
            {
              attrs: { "non-linear": "" },
              model: {
                value: _vm.stepper,
                callback: function ($$v) {
                  _vm.stepper = $$v
                },
                expression: "stepper",
              },
            },
            [
              _c(
                VStepperHeader,
                [
                  _c(
                    VStepperStep,
                    {
                      attrs: {
                        editable: "",
                        complete: _vm.stepper > 1,
                        step: "1",
                      },
                      on: {
                        click: function ($event) {
                          _vm.stepper = 1
                        },
                      },
                    },
                    [
                      _vm._v("Datos Generales"),
                      _c("small", [_vm._v("Datos del proyecto.")]),
                    ]
                  ),
                  _c(VDivider),
                  _c(
                    VStepperStep,
                    {
                      attrs: {
                        editable: "",
                        complete: _vm.stepper > 2,
                        step: "2",
                      },
                      on: {
                        click: function ($event) {
                          _vm.stepper = 2
                        },
                      },
                    },
                    [
                      _vm._v("Configuración"),
                      _c("small", [
                        _vm._v(
                          "Seleccione los datos, el bot y el canal de respuestas."
                        ),
                      ]),
                    ]
                  ),
                  _c(VDivider),
                  _c(
                    VStepperStep,
                    {
                      attrs: {
                        editable: "",
                        complete: _vm.stepper > 3,
                        step: "3",
                      },
                      on: {
                        click: function ($event) {
                          _vm.stepper = 3
                        },
                      },
                    },
                    [
                      _vm._v("Restricciones"),
                      _c("small", [_vm._v("Accesos y Permisos ")]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VStepperItems,
                [
                  _c(
                    VStepperContent,
                    { attrs: { step: "1" } },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("chatbots.projects.name"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  filled: _vm.view,
                                  disabled: _vm.view,
                                  rules: _vm.rules.name,
                                },
                                model: {
                                  value: _vm.project.project_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.project, "project_name", $$v)
                                  },
                                  expression: "project.project_name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbots.projects.business_case")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  filled: _vm.view,
                                  disabled: _vm.view,
                                  rules: _vm.rules.name,
                                },
                                model: {
                                  value: _vm.project.business_case,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.project, "business_case", $$v)
                                  },
                                  expression: "project.business_case",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbots.projects.description")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "10" } },
                            [
                              _c(VTextarea, {
                                attrs: {
                                  filled: _vm.view,
                                  dense: "",
                                  outlined: "",
                                  disabled: _vm.view,
                                  rules: _vm.rules.description,
                                  rows: 2,
                                  hint: "(Opcional)",
                                  "persistent-hint": "",
                                },
                                model: {
                                  value: _vm.project.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.project, "description", $$v)
                                  },
                                  expression: "project.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VStepperContent,
                    { attrs: { step: "2" } },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbots.projects.datastore")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(VSelect, {
                                attrs: {
                                  items: _vm.datastore,
                                  outlined: "",
                                  dense: "",
                                  filled: _vm.view,
                                  readonly: _vm.view,
                                  "item-text": "name",
                                  "return-object": "",
                                  rules: [
                                    function (v) {
                                      return (
                                        !!v || _vm.$t("common.field_required")
                                      )
                                    },
                                  ],
                                },
                                model: {
                                  value: _vm.single_datastore,
                                  callback: function ($$v) {
                                    _vm.single_datastore = $$v
                                  },
                                  expression: "single_datastore",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "btn-inca-secondary mr-1",
                                  attrs: { outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDataCenterDialog()
                                    },
                                  },
                                },
                                [_vm._v("Agregar fuente de datos")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbots.projects.connections")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(VAutocomplete, {
                                key: _vm.autocompleteKey,
                                attrs: {
                                  multiple: "",
                                  items: _vm.getDomainConnections,
                                  outlined: "",
                                  dense: "",
                                  filled: _vm.view,
                                  readonly: _vm.view,
                                  "item-text": "name",
                                  "item-value": "id",
                                  chips: "",
                                  rules: [
                                    function (v) {
                                      return (
                                        !!(v && v.length) ||
                                        _vm.$t("common.field_required")
                                      )
                                    },
                                  ],
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.printChannel()
                                  },
                                },
                                model: {
                                  value: _vm.project.connections,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.project, "connections", $$v)
                                  },
                                  expression: "project.connections",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "btn-inca-secondary mr-1",
                                  attrs: { outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openChannelDialog()
                                    },
                                  },
                                },
                                [_vm._v("Agregar canal")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("chatbots.projects.bot"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(VSelect, {
                                attrs: {
                                  items: _vm.getDomainBots,
                                  outlined: "",
                                  dense: "",
                                  filled: "",
                                  readonly: "",
                                  "item-text": "name",
                                  "item-value": "id",
                                  rules: [
                                    function (v) {
                                      return (
                                        !!(v && v.length) ||
                                        _vm.$t("common.field_required")
                                      )
                                    },
                                  ],
                                },
                                model: {
                                  value: Object.keys(_vm.project.chatbot).length
                                    ? _vm.project.chatbot
                                    : _vm.default_config.chatbot,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      Object.keys(_vm.project.chatbot).length
                                        ? _vm.project.chatbot
                                        : _vm.default_config,
                                      "chatbot",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "Object.keys(project.chatbot).length ? project.chatbot : default_config.chatbot",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(VCol, [
                            _c(
                              "fieldset",
                              { staticClass: "fieldset p-2 mb-2" },
                              [
                                _c("legend", [_vm._v(_vm._s("Datos del Bot"))]),
                                _c(
                                  VRow,
                                  [
                                    _c(
                                      VCol,
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          VSubheader,
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "chatbots.projects.assistant_name"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "4" } },
                                      [
                                        _c(VTextField, {
                                          attrs: {
                                            dense: "",
                                            outlined: "",
                                            filled: _vm.view,
                                            disabled: _vm.view,
                                            rules: _vm.rules.name,
                                          },
                                          model: {
                                            value:
                                              _vm.project.version_metadata
                                                .prompt_params.assistant_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project.version_metadata
                                                  .prompt_params,
                                                "assistant_name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "project.version_metadata.prompt_params.assistant_name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          VSubheader,
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "chatbots.projects.assistant_role"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "4" } },
                                      [
                                        _c(VTextField, {
                                          attrs: {
                                            dense: "",
                                            outlined: "",
                                            filled: _vm.view,
                                            disabled: _vm.view,
                                            rules: _vm.rules.name,
                                          },
                                          model: {
                                            value:
                                              _vm.project.version_metadata
                                                .prompt_params.assistant_role,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project.version_metadata
                                                  .prompt_params,
                                                "assistant_role",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "project.version_metadata.prompt_params.assistant_role",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          VSubheader,
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "chatbots.projects.company_name"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "4" } },
                                      [
                                        _c(VTextField, {
                                          attrs: {
                                            dense: "",
                                            outlined: "",
                                            filled: _vm.view,
                                            disabled: _vm.view,
                                            rules: _vm.rules.name,
                                          },
                                          model: {
                                            value:
                                              _vm.project.version_metadata
                                                .prompt_params.company_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project.version_metadata
                                                  .prompt_params,
                                                "company_name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "project.version_metadata.prompt_params.company_name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          VSubheader,
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "chatbots.projects.company_activity"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "4" } },
                                      [
                                        _c(VTextField, {
                                          attrs: {
                                            dense: "",
                                            outlined: "",
                                            filled: _vm.view,
                                            disabled: _vm.view,
                                            rules: _vm.rules.name,
                                          },
                                          model: {
                                            value:
                                              _vm.project.version_metadata
                                                .prompt_params.company_activity,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project.version_metadata
                                                  .prompt_params,
                                                "company_activity",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "project.version_metadata.prompt_params.company_activity",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          VSubheader,
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "chatbots.projects.conversation_purpose"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "10" } },
                                      [
                                        _c(VTextarea, {
                                          attrs: {
                                            dense: "",
                                            outlined: "",
                                            filled: _vm.view,
                                            disabled: _vm.view,
                                            rules: _vm.rules.purpose,
                                            rows: 4,
                                          },
                                          model: {
                                            value:
                                              _vm.project.version_metadata
                                                .prompt_params
                                                .conversation_purpose,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project.version_metadata
                                                  .prompt_params,
                                                "conversation_purpose",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "project.version_metadata.prompt_params.conversation_purpose",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "fieldset",
                              { staticClass: "fieldset p-2 mb-2" },
                              [
                                _c("legend", [
                                  _vm._v(_vm._s("Configuración Avanzada")),
                                ]),
                                _c(
                                  VRow,
                                  [
                                    _c(
                                      VCol,
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          VSubheader,
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "chatbots.projects.temperature"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "4" } },
                                      [
                                        _c(VSlider, {
                                          attrs: {
                                            max: "1",
                                            min: "0",
                                            step: "0.1",
                                            dense: "",
                                            outlined: "",
                                            filled: _vm.view,
                                            disabled: _vm.view,
                                            color: "primary",
                                            "hide-details": "auto",
                                            "thumb-label": "always",
                                            "thumb-color": "primary",
                                            "thumb-size": 20,
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    { staticClass: "pt-1" },
                                                    [_vm._v("1")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "prepend",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    { staticClass: "pt-1" },
                                                    [_vm._v("0")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                          model: {
                                            value:
                                              _vm.project.version_metadata
                                                .config_params.temperature,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project.version_metadata
                                                  .config_params,
                                                "temperature",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "project.version_metadata.config_params.temperature",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          VSubheader,
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "chatbots.projects.k_top_retrieval"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "4" } },
                                      [
                                        _c(VSlider, {
                                          attrs: {
                                            max: "20",
                                            min: "1",
                                            step: "1",
                                            dense: "",
                                            outlined: "",
                                            filled: _vm.view,
                                            disabled: _vm.view,
                                            color: "primary",
                                            "hide-details": "auto",
                                            "thumb-label": "always",
                                            "thumb-color": "primary",
                                            "thumb-size": 20,
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    { staticClass: "pt-1" },
                                                    [_vm._v("10")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "prepend",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    { staticClass: "pt-1" },
                                                    [_vm._v("1")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                          model: {
                                            value:
                                              _vm.project.version_metadata
                                                .config_params.k_top_retrieval,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project.version_metadata
                                                  .config_params,
                                                "k_top_retrieval",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "project.version_metadata.config_params.k_top_retrieval",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          VSubheader,
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "chatbots.projects.max_token_history"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "4" } },
                                      [
                                        _c(VSlider, {
                                          attrs: {
                                            max: "1000",
                                            min: "0",
                                            step: "100",
                                            dense: "",
                                            outlined: "",
                                            filled: _vm.view,
                                            disabled: _vm.view,
                                            color: "primary",
                                            "hide-details": "auto",
                                            "thumb-label": "always",
                                            "thumb-color": "primary",
                                            "thumb-size": 24,
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    { staticClass: "pt-1" },
                                                    [_vm._v("1000")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "prepend",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    { staticClass: "pt-1" },
                                                    [_vm._v("0")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                          model: {
                                            value:
                                              _vm.project.version_metadata
                                                .config_params
                                                .max_token_history,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project.version_metadata
                                                  .config_params,
                                                "max_token_history",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "project.version_metadata.config_params.max_token_history",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          VSubheader,
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "chatbots.projects.k_top_history"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "4" } },
                                      [
                                        _c(VSlider, {
                                          attrs: {
                                            max: "30",
                                            min: "1",
                                            step: "1",
                                            dense: "",
                                            outlined: "",
                                            filled: _vm.view,
                                            disabled: _vm.view,
                                            color: "primary",
                                            "hide-details": "auto",
                                            "thumb-label": "always",
                                            "thumb-color": "primary",
                                            "thumb-size": 20,
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    { staticClass: "pt-1" },
                                                    [_vm._v("30")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "prepend",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    { staticClass: "pt-1" },
                                                    [_vm._v("1")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ]),
                                          model: {
                                            value:
                                              _vm.project.version_metadata
                                                .config_params.k_top_history,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project.version_metadata
                                                  .config_params,
                                                "k_top_history",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "project.version_metadata.config_params.k_top_history",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VStepperContent,
                    { attrs: { step: "3" } },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbots.projects.private_access")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "10" } },
                            [
                              _c(VSwitch, {
                                attrs: {
                                  disabled: _vm.view,
                                  small: "",
                                  dense: "",
                                  hint: "¿Compatir con algunos usuarios? (Aplica solo para canales tipo 'Playground')",
                                  "persistent-hint": "",
                                },
                                model: {
                                  value: _vm.project.private_access,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.project, "private_access", $$v)
                                  },
                                  expression: "project.private_access",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.project.private_access
                        ? _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbots.projects.permissions"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c("project-permission-component", {
                                    ref: "permission_form",
                                    attrs: { view: _vm.view },
                                    model: {
                                      value: _vm.permissions,
                                      callback: function ($$v) {
                                        _vm.permissions = $$v
                                      },
                                      expression: "permissions",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(VRow, { attrs: { justify: "center" } }, [
                    _c(
                      "div",
                      { staticClass: "mb-2" },
                      [
                        _c(
                          VBtn,
                          {
                            staticClass: "default mr-1",
                            attrs: {
                              id: "link_go_list_qualities",
                              name: "link_go_list_qualities",
                              outlined: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onCancelar()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.cancel")))]
                        ),
                        _vm.stepper > 1
                          ? _c(
                              VBtn,
                              {
                                staticClass: "btn-inca-secondary mr-1",
                                attrs: { outlined: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.stepper -= 1
                                  },
                                },
                              },
                              [_vm._v("Anterior")]
                            )
                          : _vm._e(),
                        _vm.stepper < 3
                          ? _c(
                              VBtn,
                              {
                                staticClass: "btn-inca-secondary mr-1",
                                attrs: { outlined: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.stepper += 1
                                  },
                                },
                              },
                              [_vm._v("Siguiente")]
                            )
                          : _vm._e(),
                        _vm.view == false && _vm.tab != 2
                          ? _c(
                              VBtn,
                              {
                                staticClass: "primary mr-1",
                                attrs: {
                                  id: "btn_save_profiling",
                                  name: "btn_save_profiling",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.edit
                                      ? _vm.onUpdateProject()
                                      : _vm.onSaveProject()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("btns.save")))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "DialogsComponent",
        {
          ref: "dialogDatacenter",
          attrs: { title: "Agregar fuente de datos", width: 1500 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("CreateDataCenterComponent", {
                ref: "DataCenterRef",
                attrs: { mode_: "create" },
                on: { onSave: _vm.onSaveDatacenter },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  staticClass: "primary",
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveDataCenter()
                    },
                  },
                },
                [_c(VIcon, [_vm._v("mdi-send")]), _vm._v("Aceptar ")],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "DialogsComponent",
        {
          ref: "dialogChannel",
          attrs: { title: "Agregar canal", width: 1000 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("CreateChannelComponent", {
                ref: "ChannelRef",
                attrs: { mode_: "create" },
                on: { onSave: _vm.onSaveChannel },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  staticClass: "primary",
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveChannel()
                    },
                  },
                },
                [_c(VIcon, [_vm._v("mdi-send")]), _vm._v("Aceptar ")],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }